<div class="app-component-container">
  <div class="w-full h-[100%] flex flex-col">
    <div *ngFor="let s of sizes" class="invisible {{ s.css + ' ' + (prefix + s.id) }}"></div>
    <!-- To show loading message, while http call is in progress -->
    <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
    <ng-template #loadingComplete>
      <ng-container *ngIf="basketDataLoaded && collectionList.length" class="flex flex-row h-full">
        <thehubz-collections-list-actions
          *ngIf="false"
          (selectAll)="selectAll($event)"
          (sortBy)="sortBy($event)"
          [selectedViewType]="selectedViewType"
          [selectedViewSection2]="selectedViewSection2"
          [sortByNew]="sortByNew"
          (changeView)="changeView($event)"
        ></thehubz-collections-list-actions>
        <!-- Related to sharing collection message -->
        <div *ngIf="configObject?.callFrom === 'shareCollection' && configObject?.createdBy" class="w-full text-lg font-semibold mb-6 mt-1" i18n>
          Recommendation from {{ configObject.createdBy }} on {{ configObject.createdAt | spDateFormat }}
        </div>
        <div *ngIf="showFilterBubbles">
          <sp-chips-listbox-option
            [dataSource]="filterBubbles"
            [clearAllChip]="true"
            [highlighted]="false"
            [selectable]="false"
            (removeChip)="removeFilterBubble($event)"
            (removeChips)="removeAllFilterBubble()"
          ></sp-chips-listbox-option>
        </div>
        <thehubz-collection-card-view
          *ngIf="assetViewTypeService.getGridSettings('showGridView', gridSettingsKeySuffix)"
          [collectionList]="collectionList"
          [collectionSplitList]="collectionSplitList"
          [gridSettingsKeySuffix]="gridSettingsKeySuffix"
          (actionButton)="collectionActions($event)"
          (selectCollection)="selectCollection($event)"
          (updateCollection)="updateCollection($event)"
        >
        </thehubz-collection-card-view>
        <thehubz-collection-list-view
          class="h-full"
          *ngIf="assetViewTypeService.getGridSettings('showListView', gridSettingsKeySuffix)"
          [collectionList]="collectionList"
          (actionButton)="collectionActions($event)"
          (selectCollection)="selectCollection($event)"
          [selectedViewType]="selectedViewType"
          (changeView)="changeView($event)"
        >
        </thehubz-collection-list-view>
      </ng-container>
      <ng-container *ngIf="basketDataLoaded && !collectionList?.length" class="pr-3 overflow-hidden !h-40">
        <p i18n>No collection available</p>
      </ng-container>
    </ng-template>
  </div>
</div>
